"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeAutocomplete = void 0;
var attribute_autocomplete_component_1 = require("./attribute-autocomplete.component");
Object.defineProperty(exports, "AttributeAutocomplete", { enumerable: true, get: function () { return attribute_autocomplete_component_1.AttributeAutocomplete; } });
